import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export default function CompanyNameSidebar(props) {
  const {
    companyOptions = [],
    selectedCompanyId,
    setSelectedCompanyId,
    borderColor = "#e2e8f0",
  } = props;
  const onlyOne = companyOptions.length === 1;

  // If there's exactly one company, make sure it's selected
  React.useEffect(() => {
    if (onlyOne) {
      const id = companyOptions[0]?.id;
      if (id && id !== selectedCompanyId) setSelectedCompanyId(id);
    }
  }, [onlyOne, companyOptions, selectedCompanyId, setSelectedCompanyId]);

  // If there are 0 or 1 companies, render nothing (no space taken)
  if (companyOptions.length <= 1) return null;

  // Otherwise, render the select
  return (
    <Box>
      <FormControl
        fullWidth
        size="small"
        sx={{ borderRadius: "8px", backgroundColor: "white" }}
      >
        <Select
          value={selectedCompanyId ?? ""}
          onChange={(e) => setSelectedCompanyId(e.target.value)}
          sx={{
            borderRadius: "8px",
            fieldset: { borderColor },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#6d28d9",
            },
          }}
        >
          {companyOptions.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
